import {Record} from 'immutable';

export default new Record({
  id: null,
  questionId: null,
  value: null,
  comment: null,
  reason: null,
  card_reason_scheme_entry_id: null,
});
